import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ShowcaseRoutingModule } from './showcase-routing.module';
import { ShowcaseComponent } from './component/showcase/showcase.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { HttpClientModule } from '@angular/common/http';
import { MovieInfoComponent } from './component/movie-info/movie-info.component';
import { StreamComponent } from './component/stream/stream.component';
import { RateMovieComponent } from './component/dialog/new-post/rate-movie/rate-movie.component';
import { MovieComponent } from './component/movie-list/movie.component';
import { ShareButtonComponent } from './component/share-button/share-button.component';
import { MoviePageSideBarComponent } from './component/movie-info/movie-page-side-bar/movie-page-side-bar.component';
import { CustomFxModule } from 'src/app/core/custom-fx/custom-fx.module';

@NgModule({
  declarations: [
    ShowcaseComponent,
    MovieInfoComponent,
    StreamComponent,
    RateMovieComponent,
    MovieComponent,
    ShareButtonComponent,
    MoviePageSideBarComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule,
    ShowcaseRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatTabsModule,
    FlexLayoutModule,
    CustomFxModule
  ],
})
export class ShowcaseModule {}
